'use client'

import { useState, type ReactNode } from 'react'
import { Provider } from 'react-redux'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import ReduxStore from '@/store'

import { BootstrapObserver } from './addon/bootstrap'
import { LoaderObserver } from './addon/loader'
import { DialogObserver } from './addon/dialog'
import { NoticeObserver } from './addon/notice'
import { LayoutContainer } from './layout'

type ProviderProps = { children: ReactNode }

export function AppProvider({ children }: ProviderProps) {
  // __STATE's
  const [queryClient] = useState(() => new QueryClient())

  // __RENDER
  return (
    <Provider store={ReduxStore}>
      <BootstrapObserver />

      <QueryClientProvider client={queryClient}>
        <LayoutContainer>{children}</LayoutContainer>
      </QueryClientProvider>

      <LoaderObserver />
      <DialogObserver />
      <NoticeObserver />
    </Provider>
  )
}
